import React, { useState, useEffect, useCallback, use } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { auth, db } from "../firebase/firebaseconfig";
import { collection, addDoc, serverTimestamp, getDoc, doc, getDocs, query, where, updateDoc, increment,setDoc } from "firebase/firestore";
import { useGlobal } from "../App";
import { calculateBogoDiscount, calculateCategoryDiscount } from "../utils/discounts";
import { MdFileDownloadDone } from "react-icons/md";
import { deleteField } from "firebase/firestore";

const SHIPPING_COST = 65;
const FREE_SHIPPING_LIMIT = 700;

export default function Checkout() {
  const navigate = useNavigate();
  const location = useLocation();
  const user = auth.currentUser;
  const { coupons } = useGlobal();

  const [cartItems, setCartItems] = useState(location.state?.cartItems || []);
  const [formData, setFormData] = useState({
    fullName: "",
    phone: "",
    city: "",
    address: "",
    notes: "",
  });
  const [paymentMethod, setPaymentMethod] = useState("cod");
  const [subtotal, setSubtotal] = useState(0);
  const [shipping, setShipping] = useState(SHIPPING_COST);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [savedAddress, setSavedAddress] = useState(null);
  const [useSavedAddress, setUseSavedAddress] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [couponError, setCouponError] = useState("");
  const [discount, setDiscount] = useState(0);
  const [couponDiscount, setCouponDiscount] = useState(0);
  const [categoryDiscount, setCategoryDiscount] = useState(0);
  const [bogoDiscount, setBogoDiscount] = useState(0);
  const [bogoDetails, setBogoDetails] = useState([]);
  const [nocoupon, setNocoupon] = useState(false);

  


    
      const getUserDocRef = useCallback(async () => {
        if (!user?.email) return null;
        const q = query(collection(db, "Users"), where("User", "==", user.email));
        const snapshot = await getDocs(q);
        if (snapshot.empty) return null;
        return doc(db, "Users", snapshot.docs[0].id);
      }, [user?.email]);

  useEffect(() => {
    console.log('cartItems',cartItems)
    let sum = 0;
    cartItems.forEach((item) => {
      sum += (item.type === "custom" ?  item.price : item.category === "Frames" ? item.size === "30x40" ? item.bigframeprice : item.smallframeprice : item.price ) * (item.count);
    });
    setSubtotal(sum);

    const shippingCost = sum >= FREE_SHIPPING_LIMIT ? 0 : SHIPPING_COST;
    setShipping(shippingCost);


    setTotal(Math.max(0, sum + shippingCost - couponDiscount));
    console.log("subtotal", sum);
      console.log("shippingCost", shippingCost);
        console.log("couponDiscount", couponDiscount);
        console.log("total", total);
  }, [cartItems,couponDiscount, shipping]);

  // -------- VALIDATE PHONE --------
  const validatePhone = (phone) => {
    const egyptianRegex = /^01[0-2,5]\d{8}$/;
    return egyptianRegex.test(phone);
  };


  // -------- VALIDATE FORM --------
  const validateForm = () => {
    const newErrors = {};

    if (!formData.fullName.trim()) newErrors.fullName = "Name is required";
    if (!formData.phone.trim()) newErrors.phone = "Phone is required";
    if (!validatePhone(formData.phone)) newErrors.phone = "Invalid Egyptian phone number";
    if (!formData.city.trim()) newErrors.city = "City is required";
    if (!formData.address.trim()) newErrors.address = "Address is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // -------- GENERATE ORDER ID --------
const generateOrderId = () => {
  const now = new Date();

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");

  const random = Math.random().toString(36).substring(2, 6).toUpperCase();

  return `GDR-${year}-${month}-${day}-${random}`;
};




/*                               ----------------------------------------------------------                               */
  const submitOrder = async (method) => {
    if (!validateForm()) return;
    let userr 
    if (!user) {
      userr = "guest"
    }
    else{
      userr = user.email
    }
    if (!cartItems.length) {
      navigate("/cart");
      return;
    }

    setLoading(true);
    try {

      const orderId = generateOrderId();
      const isInstaPay = method === "instapay";

      const orderData = {
        orderId,
        userId: userr,
        customer: formData,
        items: cartItems,
        subtotal: subtotal,
        shipping: shipping,
        notes: formData.notes || "",
        total: total,
        paymentMethod: method,
        paymentStatus: "pending",
        status: isInstaPay ? "waiting for whatsapp" : "processing",
        timestamp: serverTimestamp(),
        Coupon : appliedCoupon ? appliedCoupon.id : 'No Coupon',
        couponDiscount : couponDiscount
        ,
      };

      console.log("📝 Saving order to Firestore:", orderData);
      await addDoc(collection(db, "Orders"), orderData);
      console.log("✅ Order saved successfully with ID:", orderId);
if (user) {
  const userRef = await getUserDocRef();
  if (userRef) {
    await updateDoc(userRef, { cart: [] });
  }
}
localStorage.removeItem("cart");
window.location.href = `/OrderDone?orderId=${orderId}
`;    } catch (error) {
      console.error("Error creating order:", error);
      alert("An error occurred, please try again");
    } finally {
      setLoading(false);
    }
  };
/*                               ----------------------------------------------------------                               */
  const handleCOD = () => submitOrder("cod");

  const handleInstaPay = () => submitOrder("instapay");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };
const updateappliedcopoun = async (COPUN) => {
  try {
    const docRef = doc(db, "utilities", "coupons");
    const docSnap = await getDoc(docRef);

    if (!docSnap.exists()) {
      setNocoupon(true);
      console.log("Coupons document does not exist.");
      return;
    }

    const data = docSnap.data();
    const couponsArray = data.coupons || [];
const existingcopoun = couponsArray.find(c => c.code === COPUN && c.isActive === true);
const existingcopoun2 = couponsArray.some(c => c.code === COPUN && c.isActive === true );
let  exists = false;
if (existingcopoun) {
  const ordersRef = collection(db, "Orders");

  const q = query(
    ordersRef,
    where("Coupon", "==", existingcopoun.id)
  );

  const snapshot = await getDocs(q);

  const usedCount = snapshot.size;

  if (!existingcopoun.maxUses || usedCount < existingcopoun.maxUses) {
    console.log("Coupon can be used. Used count:", usedCount);
    exists = true; // coupon can still be used
  } else {
    console.log("Coupon has reached its maximum uses. Used count:", usedCount);
    exists = false; // coupon reached max uses
  }

}
if (exists) {
        setNocoupon(false);
  setAppliedCoupon(existingcopoun);
  if(existingcopoun.category === '' ){
   
    if (existingcopoun.discountType === "fixed") {
      setCouponDiscount(existingcopoun.discountValue);
    }
    if (existingcopoun.discountType === "percentage") {
          console.log("npppppp category discount");
      setCouponDiscount(total * (existingcopoun.discountValue / 100));
    }
  }
        if(existingcopoun.category){
        console.log("category discount");
        const categorydiscount = cartItems.filter(item => item.category === existingcopoun.category).reduce((sum, item) => sum + (item.type === "custom" ?  item.price : item.category === "Frames" ? item.size === "30x40" ? item.bigframeprice : item.smallframeprice : item.price ) * (item.count), 0) * (existingcopoun.discountValue / 100);
        console.log("categorydiscount", categorydiscount);
        setCouponDiscount(categorydiscount);
            console.log("couponDiscount 2", couponDiscount);
            console.log(total);
      }

} 
else {
     setNocoupon(true);
}

  } catch (err) {
    console.error("Error checking coupon:", err);
  }
};
useEffect(() => {
  if (!cartItems || cartItems.length === 0) {
    navigate("/");
  }
}, [cartItems]);
  return (
    <div className="page-content checkout-page" style={{ minHeight: "100vh", paddingTop: "110px" }}>
      <div className="maxw">
        <h1 className="mb-5 text-center" style={{ marginTop: "12px" }}>Checkout</h1>

        <div className="row">
          {/* LEFT SIDE - FORM */}
          <div className="col-lg-7 order-2 order-lg-1">
            <div className="card p-4 mb-4">
              <h5 className="mb-4">📍 Shipping Information</h5>

              {/* Saved Address Option */}
              {savedAddress && (
                <div className="mb-4 p-3 border rounded" style={{ backgroundColor: "#f9f9f9" }}>
                  <div className="d-flex align-items-start gap-3">
                    <input
                      type="radio"
                      id="useSavedAddress"
                      name="addressOption"
                      checked={useSavedAddress}
                      onChange={(e) => setUseSavedAddress(e.target.checked)}
                      style={{ marginTop: "5px" }}
                    />
                    <div className="flex-grow-1">
                      <label htmlFor="useSavedAddress" className="form-label mb-2" style={{ cursor: "pointer" }}>
                        <strong>Use Saved Address</strong>
                      </label>
                      <div className="text-muted small">
                        <p className="mb-1">
                          <strong>{savedAddress.fullName}</strong> | {savedAddress.phone}
                        </p>
                        <p className="mb-0">
                          {savedAddress.city}, {savedAddress.address}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Saved Address Option - Enter New */}
              {savedAddress && (
                <div className="mb-4 p-3 border rounded" style={{ backgroundColor: "#f9f9f9" }}>
                  <div className="d-flex align-items-start gap-3">
                    <input
                      type="radio"
                      id="useNewAddress"
                      name="addressOption"
                      checked={!useSavedAddress}
                      onChange={(e) => setUseSavedAddress(!e.target.checked)}
                      style={{ marginTop: "5px" }}
                    />
                    <label htmlFor="useNewAddress" className="form-label mb-0" style={{ cursor: "pointer" }}>
                      <strong>Enter New Address</strong>
                    </label>
                  </div>
                </div>
              )}

              <div className="mb-3">
                <label className="form-label">Full Name *</label>
                <input
                  type="text"
                  className={`form-control ${errors.fullName ? "is-invalid" : ""}`}
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  placeholder="John Doe"
                  disabled={useSavedAddress}
                />
                {errors.fullName && <div className="invalid-feedback d-block">{errors.fullName}</div>}
              </div>

              <div className="mb-3">
                <label className="form-label">Phone Number *</label>
                <input
                  type="tel"
                  className={`form-control ${errors.phone ? "is-invalid" : ""}`}
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="01001234567"
                  disabled={useSavedAddress}
                />
                {errors.phone && <div className="invalid-feedback d-block">{errors.phone}</div>}
              </div>

              <div className="mb-3">
                <label className="form-label">City *</label>
                <input
                  type="text"
                  className={`form-control ${errors.city ? "is-invalid" : ""}`}
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  placeholder="Cairo"
                  disabled={useSavedAddress}
                />
                {errors.city && <div className="invalid-feedback d-block">{errors.city}</div>}
              </div>

              <div className="mb-3">
                <label className="form-label">Address *</label>
                <textarea
                  className={`form-control ${errors.address ? "is-invalid" : ""}`}
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  placeholder="Street... - Area..."
                  rows="2"                  disabled={useSavedAddress}                ></textarea>
                {errors.address && <div className="invalid-feedback d-block">{errors.address}</div>}
              </div>

              <div className="mb-4">
                <label className="form-label">Notes (Optional)</label>
                <textarea
                  className="form-control"
                  name="notes"
                  value={formData.notes}
                  onChange={handleChange}
                  placeholder="Example: Deliver in the morning"
                  rows="2"
                ></textarea>
              </div>

              <hr />

              <h5 className="mb-4">💳 Payment Method</h5>

              <div className="form-check mb-3">
                <input
                  className="form-check-input"
                  type="radio"
                  name="paymentMethod"
                  id="cod"
                  value="cod"
                  checked={paymentMethod === "cod"}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                />
                <label className="form-check-label" htmlFor="cod">
                  💰 Cash on Delivery
                </label>
              </div>

              <div className="form-check mb-4">
                <input
                  className="form-check-input"
                  type="radio"
                  name="paymentMethod"
                  id="instapay"
                  value="instapay"
                  checked={paymentMethod === "instapay"}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                />
                <label className="form-check-label" htmlFor="instapay">
                  📱 InstaPay via WhatsApp
                </label>
              </div>

              {paymentMethod === "cod" && (
                <button
                  className="btn btn-success w-100 btn-lg"
                  onClick={handleCOD}
                  disabled={loading}
                >
                  {loading ? "Processing..." : "Confirm Order"}
                </button>
              )}

              {paymentMethod === "instapay" && (
                <button
                  className="btn btn-primary w-100 btn-lg"
                  onClick={handleInstaPay}
                  disabled={loading}
                >
                  {loading ? "Processing..." : "Confirm Order"}
                </button>
              )}
            </div>
          </div>

          {/* RIGHT SIDE - SUMMARY */}
          <div className="col-lg-5 order-1 order-lg-2 mb-3 mb-lg-0">
            <div
              className="card p-4"
              style={{
                position: "sticky",
                top: "110px",
              }}
            >
              <h5 className="mb-4">📦 Order Summary</h5>

              <div className="mb-4" style={{ maxHeight: "300px", overflowY: "auto" }}>
                {cartItems && cartItems.length > 0 ? (
                  cartItems.map((item) => (
                    <div key={`${item.productId || item.name}-${item.size || "default"}`} className="d-flex justify-content-between align-items-start mb-3 pb-2 border-bottom">
                      <div className="d-flex align-items-start" style={{ flex: 1 }}>
                        <div>
                      <span>{item.type === "custom" ? item.name + (item.category === 'Frames' ? ' Custom Frame' : ' Custom Sticker') : item.name + (item.category === 'Frames' ? ' ' : ' Sticker')}<span>{item.category === 'Frames' ? item.size === '30x40' ? ' (30x40)' : ' (20x30)' : ''}</span></span>
                          <br />
                          <small className="text-muted">× {item.count}, {item.type === "custom" ?  item.price : item.category === "Frames" ? item.size === "30x40" ? item.bigframeprice : item.smallframeprice : item.price } EGP each</small>
                        </div>
                      </div>
                      <span className="fw-bold ms-2">{(item.type === "custom" ?  item.price : item.category === "Frames" ? item.size === "30x40" ? item.bigframeprice : item.smallframeprice : item.price) * item.count} EGP</span>
                    </div>
                  ))
                ) : (
                  <p className="text-muted">Cart is empty</p>
                )}
              </div>

              <hr />
              {/* COUPON CODE SECTION */}
              <div className="MB-1">
                <label className="form-label fw-bold">🎟️ Coupon Code</label>
                {!appliedCoupon ? (
                  <div className="d-flex gap-2">
                    <div className="w-100 position-relative">
                    <input
                      type="text"
                      className={`form-control ${couponError ? 'is-invalid' : ''}`}
                      value={couponCode}
                      onChange={(e) => {
                        setCouponCode(e.target.value.toUpperCase());
                        setCouponError("");
                      }}
                      placeholder="Enter code"
                    /> 
                    {nocoupon && <div className="text-danger small position-absolute">Invalid coupon</div>}</div>
                    <button 
                      className="btn btn-outline-primary" 
                      disabled={!couponCode.trim()}
                      onClick={() => updateappliedcopoun(couponCode)}
                    >
                      Apply
                    </button>
                  </div>
                ) : (
                  <div className="alert alert-success d-flex justify-content-between align-items-center mb-0 p-2">
                    <span>✅ {appliedCoupon.code}</span>
                    <button 
                      className="btn btn-sm btn-outline-danger" 
  onClick={() => {
    setAppliedCoupon(null);
    setCouponDiscount(0);
  }}                    >
                      Remove
                    </button>
                  </div>
                )}
                {couponError && <div className="text-danger small mt-1">{couponError}</div>}
              </div>
                     <div className="mb-3">
        {couponDiscount > 0 && (
         
                <p className="text-success fw-bold m-0 d-flex align-items-center">Applied <MdFileDownloadDone  className="h-100"/></p>
             
              )}
   </div>
              <div className="d-flex justify-content-between mb-2 mt-2">
                <span>Subtotal:</span>
                <span>{subtotal} EGP</span>
              </div>

              <div className="d-flex justify-content-between mb-2">
                <span>Shipping:</span>
                <span className={shipping === 0 ? "text-success" : ""}>
                  {shipping === 0 ? "Free ✨" : `${shipping} EGP`}
                </span>
              </div>
      {   appliedCoupon &&     <div className="d-flex justify-content-between mb-2">
                <span>Coupon Discount on {appliedCoupon.category ? appliedCoupon.category : "All Items"} :</span>
                <span className="text-success">
                  -{couponDiscount.toFixed(2)} EGP
                </span>
              </div>
}

              {categoryDiscount > 0 && (
                <div className="d-flex justify-content-between mb-2 text-success">
                  <span>Category discount:</span>
                  <span>- {categoryDiscount.toFixed(2)} EGP</span>
                </div>
              )}

   

      
              {discount > 0 && (
                <div className="d-flex justify-content-between mb-3 text-success">
                  <span>Total discount:</span>
                  <span>- {discount.toFixed(2)} EGP</span>
                </div>
              )}

              {subtotal < FREE_SHIPPING_LIMIT && shipping > 0 && (
                <p className="text-muted small mb-3">
                  Add {FREE_SHIPPING_LIMIT - subtotal} EGP for free shipping
                </p>
              )}

              <hr />

              <h6 className="d-flex justify-content-between">
                <span>Total:</span>
                <span className="text-danger fw-bold">{total} EGP</span>
              </h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}